import { render } from "./customizersetting.vue?vue&type=template&id=db42f31e"
import script from "./customizersetting.vue?vue&type=script&lang=js"
export * from "./customizersetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__